import type { Outcome, PromptKind } from '../shared/index.js';

export const s = {
  name: 'Şişe Çevirmece',
  pitch: 'Şişe kimi gösterirse o seçer: doğruluk mu, cesaret mi?',
  kind: { truth: 'Doğruluk', dare: 'Cesaret' } satisfies Record<PromptKind, string>,
  settings: {
    categories: 'Kategoriler',
    categoriesHint: '+18 kategoriler açık cinsel içerik içerir; yalnızca yetişkinler içindir. Cesaret görevlerinde dokunma yalnızca karşıdaki kabul ederse.',
    coupleHint: 'Çift odası: partnerinle ikiniz için. Görevler yalnızca partnerler arasında; pas hakkı her zaman var, durmak isteyen durdurur.',
    truthDare: (t: number, d: number) => `${t} doğruluk, ${d} cesaret`,
    choice: 'Doğruluk mu cesaret mi',
    choicePlayer: 'Oyuncu seçer',
    choiceRandom: 'Rastgele',
    passes: 'Pas hakkı (kişi başı)',
    unlimited: 'Sınırsız',
    passPenalty: 'Pas cezası',
    passPenaltyHint: 'Açıksa pas geçen 1 puan kaybeder.',
    vote: '“Yaptı mı?” oylaması',
    voteHint: 'Açıksa “Yaptım” diyene diğerleri oy verir; çoğunluk hayır derse puan yok.',
    order: 'Sıradaki çeviren',
    orderTarget: 'Şişenin gösterdiği',
    orderRound: 'Masada sırayla',
    rounds: 'Çevirme sayısı',
    roundsHint: (n: number) => (n === 0 ? 'Oda sahibi bitirene kadar sürer.' : `Şişe ${n} kez çevrilince oyun biter.`),
    fair: 'Adil şişe',
    fairHint: 'Son iki çevirmede seçilenlere şişenin yeniden gelme olasılığı azalır.',
    on: 'Açık',
    off: 'Kapalı',
    readOnly: 'Ayarları oda sahibi seçer.',
    add: 'Soru ya da görev ekle',
    addHint: 'Eklediğin metin “Oyuncuların ekledikleri” kategorisine girer ve herkesin oyunlarında çıkabilir.',
    addPlaceholder: { truth: 'Ör. Bu odada en çok kime güvenirsin?', dare: 'Ör. En sevdiğin şarkının nakaratını söyle.' } satisfies Record<PromptKind, string>,
    save: 'Ekle',
    saving: 'Ekleniyor…',
    saved: 'Eklendi. Bir sonraki çekilişlerde çıkabilir.',
  },
  play: {
    round: (n: number, total: number | null) => (total ? `Çevirme ${Math.min(n + 1, total)}/${total}` : `Çevirme ${n + 1}`),
    you: 'sen',
    yourTurn: 'Sıra sende',
    spunBy: (prev: string, prevIsMe: boolean, mine: boolean, next: string) =>
      `${prevIsMe ? 'Şişeyi sen çevirdin' : `Şişeyi ${prev} çevirdi`}, ${mine ? 'sıra sende' : `şimdi ${next} çevirecek`}`,
    spin: 'Şişeyi çevir',
    spinHint: 'Şişe kimi gösterirse o seçecek.',
    waitSpinner: (nick: string) => `Şişeyi ${nick} çevirecek.`,
    spinFor: (nick: string) => `${nick} yerine çevir`,
    skipSpinner: 'Sırayı atla',
    offline: (nick: string) => `${nick} bağlı değil. Sırayı atlayabilir ya da onun yerine çevirebilirsin.`,
    spinning: 'Şişe dönüyor…',
    pointed: (nick: string) => `Şişe durdu: ${nick}`,
    pointedYou: 'Şişe seni gösterdi',
    chooseHint: 'Seç: dürüstçe cevapla ya da görevi yap.',
    choosing: (nick: string) => `${nick} seçiyor: doğruluk mu, cesaret mi?`,
    done: { truth: 'Cevapladım', dare: 'Yaptım' } satisfies Record<PromptKind, string>,
    pass: 'Pas',
    passLeft: (left: number | null) => (left === null ? 'sınırsız' : `${left} hak`),
    noPass: 'Pas hakkın kalmadı',
    passCost: 'Pas geçersen 1 puan kaybedersin.',
    doing: { truth: (nick: string) => `${nick} cevaplıyor`, dare: (nick: string) => `${nick} görevi yapıyor` } satisfies Record<PromptKind, (n: string) => string>,
    voteTitle: { truth: 'Dürüstçe cevapladı mı?', dare: 'Görevi yaptı mı?' } satisfies Record<PromptKind, string>,
    yes: 'Evet',
    no: 'Hayır',
    voteWait: 'Diğerleri oyluyor…',
    voted: (n: number, total: number) => `${n}/${total} oy`,
    skipTurn: 'Turu puansız geç',
    targetOffline: (nick: string) => `${nick} bağlı değil.`,
    last: {
      done: (nick: string) => `${nick} +1 puan aldı`,
      pass: (nick: string) => `${nick} pas geçti`,
      failed: (nick: string) => `Masa ${nick} için “yapmadı” dedi`,
      skipped: (nick: string) => `${nick} için tur geçildi`,
    } satisfies Record<Outcome, (n: string) => string>,
    votes: (yes: number, no: number) => `${yes} evet, ${no} hayır`,
    scores: 'Skorlar',
    settings: 'Oyun ayarları',
    points: (n: number) => `${n} puan`,
    doneCount: (n: number) => `${n} tamam`,
    seconds: (n: number) => `${n} sn`,
  },
  podium: {
    title: 'Oyun bitti',
    winner: (nick: string) => `${nick} kazandı!`,
    tie: 'Berabere',
    back: 'Lobiye dönülüyor…',
    saved: 'Skorlar kaydedildi',
    done: (n: number) => `${n} tamam`,
  },
  howto: {
    title: 'Nasıl oynanır',
    steps: [
      ['Çevir', 'Sırası gelen “Şişeyi çevir”e basar. Şişe herkesin ekranında aynı anda döner ve aynı kişide durur.'],
      ['Seç', 'Şişenin gösterdiği kişi doğruluk ya da cesaret seçer. Soru ya da görev herkese görünür.'],
      ['Yap', 'Dürüstçe cevapla ya da görevi yap, sonra “Yaptım” de. Oylama açıksa masa karar verir.'],
      ['Puan', 'Tamamlanan her soru ve görev 1 puan. Pas hakkı sınırlıdır; ceza açıksa pas 1 puan götürür.'],
    ] as [string, string][],
  },
};
